// extracted by mini-css-extract-plugin
export default {"hide-on-desktop":"ToolbarMoreMenu-module__hide-on-desktop__ePbVixF","show-on-mobile":"ToolbarMoreMenu-module__show-on-mobile__fjVU3e6"};